import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { getLatestMovies } from "@/lib/media";
import { typeLabels } from "@/mocks/site";

export default function EditorPicks() {
  const picks = getLatestMovies(4);

  return (
    <section className="mt-12" aria-label="编辑精选">
      <SectionHeading
        eyebrow="Editor's choice"
        title="编辑精选"
        subtitle="最近上线的作品里，这几部值得先放进片单"
        actionLabel="查看全部新片"
        actionTo="/category/movie"
      />
      <div className="grid gap-3 md:grid-cols-2">
        {picks.map((movie, index) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
          >
            <div className="h-[104px] w-[70px] shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={movie.poster}
                alt={`${movie.title}海报`}
                title={`${movie.title} 影视推荐 色虎`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 text-[11px] text-foreground-400">
                <span className="font-heading text-accent-600">0{index + 1}</span>
                <span>{typeLabels[movie.type]}</span>
                <span>{movie.region}</span>
              </div>
              <h3 className="mt-1 truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
                {movie.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-500">{movie.synopsis}</p>
              <p className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-400">
                <span className="text-accent-600">★ {movie.rating.toFixed(1)}</span>
                <span>{movie.year}</span>
                <span>{movie.status}</span>
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}